module.exports = __webpack_public_path__ + "img/areport.37cbab8e.png";